export const BASE_URL = "https://www.knutrition.it";
export const SITE_BASE_URL = typeof window !== "undefined" ? window.location.origin : "";

export const DAY_KEYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
export const WEEK_ORDER = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const DAY_LABELS = {
  mon: "Lunedì",
  tue: "Martedì",
  wed: "Mercoledì",
  thu: "Giovedì",
  fri: "Venerdì",
  sat: "Sabato",
  sun: "Domenica",
};

export const DEFAULT_SETTINGS = {
  contact: {
    email: "knutrition.studio@gmail.com",
    phone: "+39 379 316 5184",
    phoneHref: "+393793165184",
    whatsapp: "393793165184",
    instagram: "https://www.instagram.com/knutritionstudio/",
    instagramHandle: "@knutritionstudio",
    addressStreet: "Via Santi Martiri Salernitani 15",
    addressCity: "Salerno",
    addressCountry: "Italia",
    mapsQuery: "Via Santi Martiri Salernitani 15, 84123 Salerno SA, Italy",
  },
  hours: {
    mon: [{ start: "09:00", end: "14:00" }],
    tue: [],
    wed: [{ start: "14:00", end: "20:00" }],
    thu: [],
    fri: [{ start: "14:00", end: "20:00" }],
    sat: [],
    sun: [],
  },
  dayNotes: {},
  onlineHours: { mon: [], tue: [], wed: [], thu: [], fri: [], sat: [], sun: [] },
  onlineConfigured: false,
  onlineNotice:
    "Gli orari per le consulenze online non sono ancora stati confermati. Indica data e orario preferiti: K Nutrition ti confermerà la disponibilità effettiva tramite WhatsApp.",
  slotIncrement: 15,
  blockedDates: [],
  brand: { logo: "/images/logo-transparent.png" },
  sections: [
    { id: "hero", type: "hero", visible: true },
    { id: "intro", type: "intro", visible: true },
    { id: "services", type: "services", visible: true },
    { id: "method", type: "method", visible: true },
    { id: "cta", type: "cta", visible: true },
  ],
  seo: {
    home: { title: "K Nutrition — Nutrizionista a Salerno | Dott.ssa Francesca Notarfrancesco", description: "K Nutrition, lo studio della Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista a Salerno. Percorsi nutrizionali personalizzati, visite in studio e consulenze online. Prenota la tua consulenza." },
    "chi-sono": { title: "Chi sono — Dott.ssa Francesca Notarfrancesco | K Nutrition Salerno", description: "Piacere, Francesca. Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista a Salerno: ascolto, personalizzazione e abitudini sostenibili per un percorso nutrizionale che dura nel tempo." },
    servizi: { title: "Servizi — Consulenze nutrizionali a Salerno e online | K Nutrition", description: "I servizi di K Nutrition: prima visita nutrizionale, controlli, check composizione corporea e consulenze online con Dott.ssa Francesca Notarfrancesco a Salerno." },
    "il-metodo": { title: "Il metodo — Il percorso nutrizionale K Nutrition | Salerno", description: "Il metodo K Nutrition in quattro passi: ascolto, valutazione, personalizzazione e monitoraggio. Un percorso nutrizionale che parte da te, con Dott.ssa Francesca Notarfrancesco a Salerno." },
    prenota: { title: "Prenota — Richiedi il tuo appuntamento | K Nutrition Salerno", description: "Richiedi il tuo appuntamento presso K Nutrition a Salerno o per una consulenza online: scegli servizio, data e orario e invia la richiesta tramite WhatsApp." },
    contatti: { title: "Contatti — Studio K Nutrition a Salerno | Nutrizionista", description: "K Nutrition, Via Santi Martiri Salernitani 15, Salerno. Telefono +39 379 316 5184, email knutrition.studio@gmail.com, Instagram @knutritionstudio. Richiedi il tuo appuntamento." },
  },
  content: {
    hero: {
      overline: "Biologa Nutrizionista · Salerno",
      line1: "Il tuo benessere,",
      line2: "la tua essenza.",
      subtitle:
        "Un percorso nutrizionale personalizzato, costruito intorno a te, alle tue esigenze e ai tuoi obiettivi.",
      ctaPrimary: "Prenota una consulenza",
      ctaSecondary: "Scopri K Nutrition",
      ctaPrimaryLink: "/prenota",
      ctaSecondaryLink: "/chi-sono",
    },
    intro: {
      overline: "K Nutrition",
      title: "Un approccio nutrizionale umano, su misura e sostenibile.",
      text: "K Nutrition è lo studio di Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista a Salerno. Un percorso che parte da te: dal tuo ritmo, dalle tue abitudini e dai tuoi obiettivi, per costruire un equilibrio che possa accompagnarti nel tempo.",
    },
    method: {
      statement:
        "Il percorso nutrizionale parte da te: dalle tue esigenze, dalle tue abitudini e dai tuoi obiettivi, per costruire insieme un equilibrio che possa accompagnarti nel tempo.",
      steps: [
        { n: "01", title: "Ascolto", text: "Ogni percorso inizia dall'ascolto: della tua storia, delle tue abitudini, dei tuoi ritmi e di ciò che desideri raggiungere." },
        { n: "02", title: "Valutazione", text: "Valutazione approfondita e analisi della composizione corporea tramite BIA, per conoscere il tuo punto di partenza." },
        { n: "03", title: "Personalizzazione", text: "Il piano alimentare è costruito su misura per te: flessibile, realistico e pensato per la tua vita di ogni giorno." },
        { n: "04", title: "Monitoraggio", text: "I controlli periodici mantengono la rotta: rivediamo insieme i risultati e adattiamo il percorso, passo dopo passo." },
      ],
    },
    services: {
      title: "I servizi",
      homeTitle: "Percorsi su misura, in studio e online",
      text: "Percorsi nutrizionali in studio a Salerno e consulenze online, pensati per accompagnarti con continuità verso i tuoi obiettivi.",
    },
    about: {
      title: "Piacere, Francesca.",
      lead: "Dietro K Nutrition c'è Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista: un approccio che unisce competenza scientifica, ascolto genuino e cura della persona.",
      biography: "[Testo da completare — aggiungi qui la biografia completa di Dott.ssa Francesca Notarfrancesco prima della pubblicazione.]",
      education: "[Formazione universitaria — da completare con ateneo, laurea e titolo professionale.]",
      training: "[Aggiornamento professionale e formazione complementare — da completare.]",
      registration: "[Informazioni sull'ordine professionale di appartenenza — da completare.]",
      philosophyTitle: "La mia filosofia",
      philosophyText: "Non esiste una dieta valida per tutti: esiste il tuo equilibrio. Lavoriamo insieme per costruire abitudini sane e sostenibili, senza sensi di colpa e senza rinunce forzate, rispettando i tuoi tempi e la tua vita.",
      aboutEyebrow: "Chi sono",
      biographyTitle: "Biografia",
      biographyQuote: "",
      educationTitle: "Formazione universitaria",
      trainingTitle: "Aggiornamento professionale",
      registrationTitle: "Iscrizione all'ordine professionale",
      philosophyHeading: "Equilibrio, non regole rigide.",
      ctaTitle: "Iniziamo insieme.",
      ctaButton: "Prenota una consulenza",
    },
    cta: {
      title: "Inizia il tuo percorso.",
      text: "Richiedi il tuo appuntamento: la disponibilità sarà confermata direttamente da K Nutrition tramite WhatsApp.",
      button: "Prenota una consulenza",
      buttonLink: "/prenota",
    },
    prenota: {
      title: "Richiedi il tuo appuntamento",
      text: "Scegli il servizio, indica data e orario preferiti e invia la richiesta tramite WhatsApp. K Nutrition confermerà direttamente la disponibilità.",
    },
    contacts: {
      title: "Contatti",
      text: "Lo studio ti aspetta in centro a Salerno. Scrivi, chiama o passaci a trovare.",
    },
    footerNote: "K Nutrition — Dott.ssa Francesca Notarfrancesco, Biologa Nutrizionista",
  },
  photos: {
    hero: "/images/supermarket.jpg",
    about: "/images/carrot.jpg",
    philosophy: "/images/supermarket-2.jpg",
    services: "/images/broccoli-back.jpg",
    aboutSecond: "/images/portrait-front.jpg",
    profile: "/images/portrait-profile.jpg",
    method: "/images/broccoli.jpg",
    lifestyle: "/images/kn-produce-still.jpg",
  },
};

export function mergeSettings(remote) {
  if (!remote) return DEFAULT_SETTINGS;
  const out = { ...DEFAULT_SETTINGS };
  for (const key of Object.keys(DEFAULT_SETTINGS)) {
    if (remote[key] === undefined) continue;
    if (key === "contact" || key === "content" || key === "photos" || key === "brand") {
      out[key] = { ...DEFAULT_SETTINGS[key], ...remote[key] };
    } else if (key === "seo") {
      out[key] = Object.fromEntries(
        Object.keys(DEFAULT_SETTINGS.seo).map((p) => [p, { ...(DEFAULT_SETTINGS.seo[p] || {}), ...((remote[key] || {})[p] || {}) }]),
      );
    } else if (key === "sections") {
      out[key] = Array.isArray(remote[key]) && remote[key].length ? remote[key] : DEFAULT_SETTINGS.sections;
    } else {
      out[key] = remote[key];
    }
  }
  return out;
}

export function photoPosition(settings, key, fallback = "50% 50%") {
  const f = settings?.photosFraming?.[key];
  return f ? `${f.x}% ${f.y}%` : fallback;
}

/* ---------- Time helpers (Europe/Rome) ---------- */

export function romeNow() {
  return new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Rome" }));
}

export function romeToday() {
  return romeNow().toLocaleDateString("en-CA");
}

export function hmToMinutes(hm) {
  const [h, m] = String(hm).split(":").map(Number);
  return h * 60 + (m || 0);
}

export function minutesToHM(total) {
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function weekdayKey(dateStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  return DAY_KEYS[new Date(y, m - 1, d).getDay()];
}

export function formatDateIt(dateStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Intl.DateTimeFormat("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(new Date(y, m - 1, d));
}

export function isDateBlocked(dateStr, settings) {
  return (settings.blockedDates || []).includes(dateStr);
}

export function slotsForDate(dateStr, service, settings) {
  const windows = (settings.hours || {})[weekdayKey(dateStr)] || [];
  const duration = service.duration;
  const inc = settings.slotIncrement || 15;
  const slots = [];
  for (const w of windows) {
    const start = hmToMinutes(w.start);
    const end = hmToMinutes(w.end);
    for (let t = start; t + duration <= end; t += inc) {
      slots.push(t);
    }
  }
  return slots.sort((a, b) => a - b).map(minutesToHM);
}

export function slotIsPast(dateStr, hm) {
  if (dateStr !== romeToday()) return false;
  const now = romeNow();
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  return hmToMinutes(hm) <= nowMinutes;
}

export function dateIsSelectable(dateStr, settings, mode) {
  if (dateStr < romeToday()) return false;
  if (isDateBlocked(dateStr, settings)) return false;
  if (mode === "studio") {
    const windows = (settings.hours || {})[weekdayKey(dateStr)] || [];
    if (windows.length === 0) return false;
  }
  return true;
}

export function buildWhatsAppMessage({ name, service, date, time }) {
  return [
    "Buongiorno K Nutrition!",
    "",
    "Vorrei richiedere un appuntamento.",
    "",
    `Nome: ${name}`,
    `Servizio: ${service.name}`,
    `Data desiderata: ${formatDateIt(date)}`,
    `Orario desiderato: ${time}`,
    "",
    "Resto in attesa di conferma della disponibilità.",
    "",
    "Grazie!",
  ].join("\n");
}

export function buildInfoMessage(service) {
  if (!service) {
    return [
      "Buongiorno K Nutrition!",
      "",
      "Vorrei ricevere alcune informazioni sui servizi e sui prezzi.",
      "",
      "Grazie!",
    ].join("\n");
  }
  return [
    "Buongiorno K Nutrition!",
    "",
    "Vorrei ricevere alcune informazioni su questo servizio.",
    "",
    `Servizio: ${service.name}`,
    "",
    "Grazie!",
  ].join("\n");
}

export function buildBookingWhatsApp({ name, service, date, time, ref }) {
  const lines = [
    "Buongiorno K Nutrition!",
    "",
    "Ho appena inviato una richiesta di appuntamento dal sito.",
    "",
    `Nome: ${name}`,
    `Servizio: ${service.name}`,
    `Data desiderata: ${formatDateIt(date)}`,
    `Orario desiderato: ${time}`,
  ];
  if (ref) lines.push(`Codice richiesta: ${ref}`);
  lines.push("", "Resto in attesa di conferma della disponibilità.", "", "Grazie!");
  return lines.join("\n");
}

export function whatsappUrl(number, message) {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

/* ---------- Admin → patient WhatsApp (messages opened as drafts, never auto-sent) ---------- */

export function normalizePhoneWa(phone) {
  let digits = String(phone || "").replace(/[^0-9]/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.length >= 11 && digits.startsWith("39")) return digits;
  return `39${digits}`;
}

export function patientWhatsAppUrl(phone, message) {
  return whatsappUrl(normalizePhoneWa(phone), message);
}

function formatApptWhen(date, time) {
  return `${formatDateIt(date)} alle ${time}`;
}

const TOMORROW_ISO = () => new Date(Date.now() + 24 * 60 * 60 * 1000).toLocaleDateString("en-CA");

export function buildAdminReminderMessage({ name, service, date, time, end, mode, serviceId }) {
  const tom = date === TOMORROW_ISO() ? " di domani" : "";
  const dataIt = formatDateIt(date);
  const firma = "\n\nCordiali saluti,\nDott.ssa Francesca Notarfrancesco\nBiologa Nutrizionista";
  const documenti =
    "• Eventuali esami ematochimici recenti\n" +
    "• Elenco di eventuali patologie, allergie, intolleranze o particolari condizioni cliniche (ad es. diabete, insulino-resistenza, patologie tiroidee, ipertensione, disturbi gastrointestinali, celiachia, allergie o intolleranze alimentari, PCOS, gravidanza/allattamento, patologie renali o epatiche)\n" +
    "• Elenco di eventuali farmaci e/o integratori assunti regolarmente";

  if (serviceId === "prima-visita") {
    return (
      `Buongiorno ${name},\n` +
      `in vista della visita nutrizionale${tom} (${dataIt} alle ore ${time}), le chiedo cortesemente di inviarmi i seguenti documenti e informazioni:\n` +
      documenti + "\n\n" +
      "Inoltre, poiché durante la visita potrà essere effettuata la valutazione della composizione corporea mediante bioimpedenziometria (BIA), per garantire una misurazione il più possibile attendibile, le chiedo gentilmente di seguire alcune semplici indicazioni:\n" +
      "• Digiuno: evitare di consumare pasti nelle 2–3 ore precedenti la visita.\n" +
      "• Idratazione: mantenere una normale idratazione, evitando di bere grandi quantità d'acqua immediatamente prima dell'esame.\n" +
      "• Attività fisica: evitare allenamenti intensi nelle 12 ore precedenti la misurazione.\n" +
      "• Alcol: evitare il consumo di bevande alcoliche nelle 24 ore precedenti.\n" +
      "• Creme e oli: non applicare creme, oli o altri prodotti cosmetici su mani e piedi il giorno della visita, per favorire il corretto posizionamento degli elettrodi.\n" +
      "• Prima della misurazione: svuotare la vescica, possibilmente entro 30 minuti dall'esame.\n\n" +
      "Le restanti informazioni verranno raccolte e approfondite insieme durante la visita.\n" +
      "Resto a disposizione per qualsiasi chiarimento." +
      firma
    );
  }

  if (serviceId === "prima-consulenza-online") {
    return (
      `Buongiorno ${name},\n` +
      `in vista della visita nutrizionale online${tom} (${dataIt} alle ore ${time}), le chiedo cortesemente di inviarmi i seguenti documenti e informazioni:\n` +
      documenti + "\n\n" +
      "Le invierò il link della videochiamata poco prima dell'orario concordato.\n" +
      "Le restanti informazioni verranno raccolte e approfondite insieme durante la visita.\n" +
      "Resto a disposizione per qualsiasi chiarimento." +
      firma
    );
  }

  if (serviceId === "controllo-nutrizionale" || serviceId === "controllo-online") {
    return (
      `Buongiorno ${name},\n` +
      `le ricordo il controllo${tom} alle ore ${time} (${dataIt}).\n\n` +
      (mode === "online" || serviceId === "controllo-online" ? "Le invierò il link della videochiamata poco prima.\n\n" : "") +
      "Se non può più partecipare, avvisi rispondendo a questo messaggio. A presto!"
    );
  }

  const lines = [
    `Buongiorno ${name}, sono Francesca di K Nutrition.`,
    "",
    "Le ricordo il suo appuntamento" + tom + ":",
    `Servizio: ${service}`,
    `Data: ${dataIt}`,
    `Orario: ${time}–${end}`,
    "",
    mode === "online"
      ? "Le invierò il link della videochiamata poco prima. Tenete a portata i risultati delle analisi."
      : "Le chiedo di presentarsi A DIGIUNO (nelle 12 ore precedenti solo acqua) e di portare con sé i risultati delle analisi.",
    "",
    "Se non può più partecipare, avvisi rispondendo a questo messaggio. A domani!",
  ];
  return lines.join("\n");
}

export function buildAdminConfirmMessage({ name, service, date, time, end, mode }) {  const lines = [
    `Buongiorno ${name}, sono Francesca di K Nutrition.`,
    "",
    "La sua richiesta di appuntamento è confermata:",
    `Servizio: ${service}`,
    `Data: ${formatDateIt(date)}`,
    `Orario: ${time}–${end}`,
    "",
    mode === "online"
      ? "Le invierò il link per la videochiamata poco prima dell'appuntamento."
      : "La aspetto nello studio in Via Santi Martiri Salernitani 15, Salerno.",
    "Se non può più partecipare, avvisi rispondendo a questo messaggio. Grazie!",
  ];
  return lines.join("\n");
}

export function buildAdminRejectMessage({ name, service, date, time }) {
  return [
    `Buongiorno ${name}, sono Francesca di K Nutrition.`,
    "",
    `Purtroppo l'orario richiesto per ${formatApptWhen(date, time)} (servizio: ${service}) non è disponibile.`,
    "",
    "Se le fa piacere, possiamo trovare insieme un'altra data: mi scriva qui per organizzarci. Grazie!",
  ].join("\n");
}

export function buildAdminContactMessage({ name, service, date, time }) {
  return [
    `Buongiorno ${name}, sono Francesca di K Nutrition.`,
    "",
    `La contatto in merito al suo appuntamento (${service}, ${formatApptWhen(date, time)}).`,
  ].join("\n");
}
